document.addEventListener("DOMContentLoaded", function () {
    // ========== MEDIA GALLERY FUNCTIONALITY ==========
    const thumbnails = document.querySelectorAll('.gkd-thumbnail');
    const mainTrack = document.querySelector('.gkd-main-media-track');
    const slides = document.querySelectorAll('.gkd-slide');
    const prevBtn = document.querySelector('.gkd-prev');
    const nextBtn = document.querySelector('.gkd-next');
    const thumbContainer = document.querySelector('.gkd-thumbnails');
    const navUp = document.querySelector('.gkd-nav-up');
    const navDown = document.querySelector('.gkd-nav-down');
    const navLeft = document.querySelector('.gkd-nav-left');
    let currentIndex = 0;
    let startX = 0;
    let endX = 0;

    function updateSlider(index) {
        if (mainTrack && thumbnails.length > 0) {
            const visibleSlides = Array.from(slides).filter(slide => 
                slide.style.display !== 'none'
            );
            
            if (visibleSlides.length === 0) return;
            
            if (index >= visibleSlides.length) {
                index = visibleSlides.length - 1;
            }
            if (index < 0) {
                index = 0;
            }
            
            currentIndex = index;
            
            mainTrack.style.transform = `translateX(-${index * 100}%)`;
            thumbnails.forEach(thumb => thumb.classList.remove('active'));
            
            const visibleThumbnails = Array.from(thumbnails).filter(thumb => 
                thumb.style.display !== 'none'
            );
            if (visibleThumbnails[index]) {
                visibleThumbnails[index].classList.add('active');
            }
        }
    }

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', function () {
            const visibleThumbnails = Array.from(thumbnails).filter(thumb => 
                thumb.style.display !== 'none'
            );
            const visibleIndex = visibleThumbnails.indexOf(this);
            currentIndex = visibleIndex >= 0 ? visibleIndex : 0;
            updateSlider(currentIndex);
        });
    });

    if (prevBtn) {
        prevBtn.addEventListener('click', function () {
            const visibleSlides = Array.from(slides).filter(slide => 
                slide.style.display !== 'none'
            );
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider(currentIndex);
            }
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function () {
            const visibleSlides = Array.from(slides).filter(slide => 
                slide.style.display !== 'none'
            );
            if (currentIndex < visibleSlides.length - 1) {
                currentIndex++;
                updateSlider(currentIndex);
            }
        });
    }

    if (navUp) {
        navUp.addEventListener('click', function () {
            thumbContainer.scrollBy({ top: -80, behavior: 'smooth' });
        });
    }

    if (navDown) {
        navDown.addEventListener('click', function () {
            thumbContainer.scrollBy({ top: 80, behavior: 'smooth' });
        });
    }

    if (navLeft) {
        navLeft.addEventListener('click', function () {
            thumbContainer.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // Touch swipe for mobile
    if (mainTrack) {
        mainTrack.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });

        mainTrack.addEventListener('touchmove', (e) => {
            endX = e.touches[0].clientX;
        });

        mainTrack.addEventListener('touchend', () => {
            const visibleSlides = Array.from(slides).filter(slide => 
                slide.style.display !== 'none'
            );
            if (startX - endX > 50 && currentIndex < visibleSlides.length - 1) {
                currentIndex++;
                updateSlider(currentIndex);
            } else if (endX - startX > 50 && currentIndex > 0) {
                currentIndex--;
                updateSlider(currentIndex);
            }
        });
    }

    // ========== IMAGE FILTERING BY VARIANT ==========
    function filterImagesByVariant(selectedVariantName) {
        if (!selectedVariantName) return;
        
        const variantLower = selectedVariantName.toLowerCase();
        
        slides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            const thumbnail = thumbnails[index];
            
            if (img && thumbnail) {
                const altText = img.getAttribute('alt') || '';
                const altLower = altText.toLowerCase();
                
                const shouldShow = altLower.includes(variantLower) || 
                                  altText.trim() === '' ||
                                  !hasAnyVariantName(altLower);
                
                if (shouldShow) {
                    slide.style.display = 'block';
                    thumbnail.style.display = 'block';
                } else {
                    slide.style.display = 'none';
                    thumbnail.style.display = 'none';
                }
            }
        });
        
        currentIndex = 0;
        updateSlider(0);
    }
    
    function hasAnyVariantName(altTextLower) {
        // Get all variant option values to check against
        const variantInputs = document.querySelectorAll('.gkd-variant-swatch');
        const variantNames = [];
        
        variantInputs.forEach(input => {
            const value = input.value.toLowerCase();
            if (value && !variantNames.includes(value)) {
                variantNames.push(value);
            }
        });
        
        return variantNames.some(name => altTextLower.includes(name));
    }

    // ========== VARIANT & BUNDLE FUNCTIONALITY ==========
    const bundleWrappers = document.querySelectorAll('.gkd-bundle-wrapper');
    const qtyInput = document.querySelector('.gkd-qty-input');
    const totalPriceElement = document.getElementById('gkd-total-price');
    const productForm = document.querySelector('.gkd-product-form');
    const submitButton = productForm?.querySelector('button[type="submit"]');
    const buttonText = submitButton?.querySelector('span');

    // Store selected options for multi-option products
    let selectedOptions = {};

    // Setup variant listeners - works with any number of options
    function setupVariantSwatches() {
        const variantInputs = document.querySelectorAll('.gkd-variant-swatch');
        const variantIdInput = productForm?.querySelector('.product-variant-id');
        
        variantInputs.forEach(input => {
            input.addEventListener('change', function() {
                if (this.checked) {
                    const optionValue = this.value;
                    const optionPosition = this.getAttribute('data-option-position');
                    
                    console.log('=== VARIANT OPTION CHANGED ===');
                    console.log('Option Position:', optionPosition);
                    console.log('Option Value:', optionValue);
                    
                    // Store the selected option
                    selectedOptions[optionPosition] = optionValue;
                    
                    // Update the displayed value
                    const displayElement = document.querySelector(`.selected-variant-value-${optionPosition}`);
                    if (displayElement) {
                        displayElement.textContent = optionValue;
                    }
                    
                    // For single-option products, directly use the variant ID
                    const variantId = this.getAttribute('data-variant-id');
                    if (variantId && variantIdInput) {
                        variantIdInput.value = variantId;
                        console.log('✓ Variant ID set to:', variantId);
                    }
                    
                    // Filter images by the first option (usually color)
                    if (optionPosition === '1') {
                        filterImagesByVariant(optionValue);
                    }
                    
                    console.log('===============================');
                }
            });
        });
        
        // Set initial variant on page load
        const checkedInputs = document.querySelectorAll('.gkd-variant-swatch:checked');
        checkedInputs.forEach(input => {
            const optionPosition = input.getAttribute('data-option-position');
            selectedOptions[optionPosition] = input.value;
        });
        
        // Set initial variant ID
        const firstCheckedInput = document.querySelector('.gkd-variant-swatch:checked');
        if (firstCheckedInput && variantIdInput) {
            const variantId = firstCheckedInput.getAttribute('data-variant-id');
            if (variantId) {
                variantIdInput.value = variantId;
                console.log('Initial variant set to:', variantId);
            }
            
            // Filter images by first option
            if (firstCheckedInput.getAttribute('data-option-position') === '1') {
                filterImagesByVariant(firstCheckedInput.value);
            }
        }
    }

    // Get current variant ID
    function getCurrentVariantId() {
        const variantIdInput = productForm?.querySelector('.product-variant-id');
        if (variantIdInput && variantIdInput.value) {
            console.log('Getting variant ID:', variantIdInput.value);
            return variantIdInput.value;
        }
        
        // Fallback: get from checked swatch
        const checkedSwatch = document.querySelector('.gkd-variant-swatch:checked');
        if (checkedSwatch) {
            const variantId = checkedSwatch.getAttribute('data-variant-id');
            console.log('Getting variant ID from swatch:', variantId);
            return variantId;
        }
        
        console.error('No variant ID found!');
        return null;
    }

    // Update total price display
    function updateTotalPrice() {
        const selectedBundle = document.querySelector('.gkd-bundle-option input:checked');
        if (!selectedBundle || !totalPriceElement) return;

        const pricePerItem = parseFloat(selectedBundle.getAttribute('data-price'));
        const hasQuantity = selectedBundle.getAttribute('data-has-quantity') === 'true';
        let quantity = parseInt(selectedBundle.value);
        
        if (hasQuantity && qtyInput) {
            quantity = parseInt(qtyInput.value);
        }
        
        totalPriceElement.textContent = (pricePerItem * quantity).toFixed(2);
    }

    function resetButton() {
        if (submitButton) {
            submitButton.disabled = false;
            if (buttonText) {
                buttonText.textContent = 'Add to Cart';
            }
        }
    }

    function setButtonLoading() {
        if (submitButton) {
            submitButton.disabled = true;
            if (buttonText) {
                buttonText.textContent = 'Adding...';
            }
        }
    }

    // Show/hide quantity selector based on bundle selection
    function updateQuantitySelector() {
        const selectedBundle = document.querySelector('.gkd-bundle-option input:checked');
        if (!selectedBundle) return;

        // Hide all quantity selectors first
        const allQuantitySelectors = document.querySelectorAll('.gkd-quantity-selector');
        allQuantitySelectors.forEach(selector => {
            selector.style.display = 'none';
        });

        // Show the quantity selector for the selected bundle if it has one
        const hasQuantity = selectedBundle.getAttribute('data-has-quantity') === 'true';
        if (hasQuantity) {
            const wrapper = selectedBundle.closest('.gkd-bundle-wrapper');
            const quantitySelector = wrapper?.querySelector('.gkd-quantity-selector');
            if (quantitySelector) {
                quantitySelector.style.display = 'flex';
            }
        }
    }

    // Bundle option selection
    bundleWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', function (event) {
            if (event.target.closest('.gkd-quantity-selector')) return;

            const input = this.querySelector('.gkd-bundle-option input');
            if (input) {
                input.checked = true;
                updateQuantitySelector();
                updateTotalPrice();
            }
        });
    });

    // Quantity controls
    const qtyPlusBtn = document.querySelector('.gkd-qty-plus');
    const qtyMinusBtn = document.querySelector('.gkd-qty-minus');

    if (qtyPlusBtn) {
        qtyPlusBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            const input = this.closest('.gkd-quantity-selector').querySelector('.gkd-qty-input');
            if (input) {
                input.value = parseInt(input.value) + 1;
                updateTotalPrice();
            }
        });
    }

    if (qtyMinusBtn) {
        qtyMinusBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            const input = this.closest('.gkd-quantity-selector').querySelector('.gkd-qty-input');
            const minValue = parseInt(input.getAttribute('min'));
            if (input && parseInt(input.value) > minValue) {
                input.value = parseInt(input.value) - 1;
                updateTotalPrice();
            }
        });
    }

    if (qtyInput) {
        qtyInput.addEventListener('input', function (event) {
            event.stopPropagation();
            const minValue = parseInt(this.getAttribute('min'));
            if (parseInt(this.value) < minValue) {
                this.value = minValue;
            }
            updateTotalPrice();
        });
    }

    // ========== FORM SUBMISSION ==========
    if (productForm) {
        productForm.addEventListener('submit', function(event) {
            event.preventDefault();
            event.stopPropagation();

            const variantId = getCurrentVariantId();
            const selectedBundle = document.querySelector('.gkd-bundle-option input:checked');
            
            if (!selectedBundle) {
                alert('Please select a bundle option');
                return false;
            }

            const hasQuantity = selectedBundle.getAttribute('data-has-quantity') === 'true';
            let quantity = parseInt(selectedBundle.value);
            
            if (hasQuantity) {
                const wrapper = selectedBundle.closest('.gkd-bundle-wrapper');
                const qtyInput = wrapper?.querySelector('.gkd-qty-input');
                if (qtyInput) {
                    quantity = parseInt(qtyInput.value);
                }
            }

            if (!variantId) {
                alert('Please select a product variant');
                return false;
            }

            console.log('=== SUBMITTING TO CART ===');
            console.log('Variant ID:', variantId);
            console.log('Quantity:', quantity);
            console.log('Selected Options:', selectedOptions);
            console.log('==========================');

            setButtonLoading();

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ 
                    id: parseInt(variantId),
                    quantity: quantity 
                })
            })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => {
                        throw new Error(err.description || 'Failed to add to cart');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('✓ Added to cart successfully:', data);
                window.location.href = "/checkout";
            })
            .catch(error => {
                console.error('✗ Error:', error);
                alert('There was an error adding the product to your cart: ' + error.message);
                resetButton();
            });

            return false;
        });
    }

    resetButton();

    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            resetButton();
        }
    });

    document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
            resetButton();
        }
    });

    // Initialize
    setupVariantSwatches();
    updateQuantitySelector();
    updateTotalPrice();
});